<script setup lang="ts">
/**
 * 微信内置浏览器全屏居中提示。
 *
 * 由 App.vue 检测到微信后通过 v-if 挂载本组件，本组件只负责展示提示内容。
 * 微信下 getUserMedia 不可用，程序无法使用，必须引导用户用系统浏览器打开。
 */
</script>

<template>
  <div
    class="wechat-block"
    role="alertdialog"
    aria-modal="true"
    aria-label="请在浏览器中打开"
  >
    <!-- 警示图标 -->
    <svg
      class="wechat-block__icon"
      viewBox="0 0 24 24"
      width="56"
      height="56"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
      />
      <line
        x1="12"
        y1="7"
        x2="12"
        y2="13"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <circle cx="12" cy="16.5" r="1.2" fill="currentColor" />
    </svg>

    <!-- 标题 -->
    <h2 class="wechat-block__title">请在浏览器中打开</h2>

    <!-- 说明 -->
    <p class="wechat-block__desc">
      微信内置浏览器不支持麦克风功能，无法使用语音助手。
    </p>

    <!-- 操作指引 -->
    <div class="wechat-block__guide">
      <div class="wechat-block__step">
        <span class="wechat-block__dot">1</span>
        <span>点击右上角 <strong>···</strong></span>
      </div>
      <div class="wechat-block__step">
        <span class="wechat-block__dot">2</span>
        <span>选择「在浏览器中打开」</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
/*
 * 页面级容器：微信下整个 App 内容被 v-if 隐藏，
 * 这个组件独占视口，背景透明，沿用 body 背景色，提示信息自然居中。
 */
.wechat-block {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
  color: #1f1f1f;
}

.wechat-block__icon {
  color: #e6a700;
  margin-bottom: 16px;
}

.wechat-block__title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
}

.wechat-block__desc {
  margin: 0 0 24px;
  font-size: 14px;
  line-height: 1.5;
  color: #555;
}

.wechat-block__guide {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.wechat-block__step {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  text-align: left;

  strong {
    font-weight: 600;
    color: #1f1f1f;
  }
}

.wechat-block__dot {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #007aff;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

// 小屏手机略紧凑
@media (max-width: 360px) {
  .wechat-block__title {
    font-size: 17px;
  }
}
</style>
